export class ApiError extends Error {
    public response: Response;

    constructor(response: Response, message?: string) {
        super(message || response.statusText);
        this.response = response;
    }
}

/**
 * This cannot be tested due to a long-standing bug in jest testing and instanceof
 * https://github.com/jestjs/jest/issues/6788
 */
export function retryError(e: any, isOnMobileApp: boolean): boolean {
    const noRetryStatuses: number[] = isOnMobileApp ? [403] : [401, 403];
    return !(e instanceof ApiError && noRetryStatuses.includes(e.response.status));
}
